import { z } from 'zod';
import { emailSchema } from './common.dto';
import { UserRole, UserStatus } from '../enums';

/** User / staff management DTOs (SUPER_ADMIN manages users; ADMIN manages agents). */

export const inviteUserSchema = z.object({
  email: emailSchema,
  /** Canonical display name; the UI derives it from firstName + lastName. */
  fullName: z.string().trim().min(1).max(160),
  /** Contact person split (reference form: Nombre / Apellido). */
  firstName: z.string().trim().max(120).optional(),
  lastName: z.string().trim().max(120).optional(),
  role: z.nativeEnum(UserRole),
  /** Office / "Agente responsable"; UI constrains to the ResponsibleOffice values. */
  office: z.string().trim().max(120).optional(),
  phone: z.string().trim().max(40).optional(),
});
export type InviteUserDto = z.infer<typeof inviteUserSchema>;

export const updateUserSchema = z.object({
  fullName: z.string().trim().min(1).max(160).optional(),
  firstName: z.string().trim().max(120).optional(),
  lastName: z.string().trim().max(120).optional(),
  role: z.nativeEnum(UserRole).optional(),
  office: z.string().trim().max(120).optional(),
  phone: z.string().trim().max(40).optional(),
  /** Fixed commission rate per agent in basis points (1250 = 12.50 %), 0–50 %; Super Admin only; null clears. */
  commissionRateBp: z.number().int().min(0).max(5000).nullable().optional(),
});
export type UpdateUserDto = z.infer<typeof updateUserSchema>;

export const setUserStatusSchema = z.object({
  status: z.nativeEnum(UserStatus),
});
export type SetUserStatusDto = z.infer<typeof setUserStatusSchema>;
